import "./index.es468.js";
import "./index.es469.js";
import "./index.es470.js";
import { MEDIAN_AGE_BINS as o } from "./index.es471.js";
import "./index.es472.js";
import "./index.es473.js";
import "./index.es91.js";
import "./index.es92.js";
import { POP_DENSITY_STATIC_COUNTY_BINS as t, POP_DENSITY_STATIC_ZIPCODE_BINS as i, POP_DENSITY_STATIC_CBG_BINS as a } from "./index.es474.js";
import { DEFAULT_ZOOM_DETAILS as e } from "./index.es477.js";
import "./index.es478.js";
const u = {
  bachelorsDegreeAndHigher: {
    id: "bachelorsDegreeAndHigher",
    name: "Bachelors Degree and Higher",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "edu_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "Bach_p",
    legendRangeType: "Percentile",
    legendDescPrefix: "% of Population, ",
    bucketingMode: "dynamic",
    dynamicBucketingConfig: {
      paletteKey: "Purple"
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  maidenAge: {
    id: "maidenAge",
    name: "Median Age",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "age_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "median_age",
    legendRangeType: "Numeric",
    legendDescPrefix: "Years, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: o,
      zipcode: o,
      county: o,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  medianHouseholdIncome: {
    id: "medianHouseholdIncome",
    name: "Median Household Income",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "hhi_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "median_hhi",
    legendRangeType: "Income",
    legendDescPrefix: "",
    bucketingMode: "dynamic",
    dynamicBucketingConfig: {
      paletteKey: "Yellow Green"
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  populationDensity: {
    id: "populationDensity",
    name: "Population Density",
    disabledText: "",
    layerCategory: "Demographics",
    dataSource: "STI: Popstats (2023)",
    tileSource: "pop_popstats_2023",
    tileCategory: "demographics",
    propertyKey: "pop_density",
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "Population per sq. mile, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: a,
      zipcode: i,
      county: t,
      cbsa: []
    },
    zoomDetails: e,
    vizType: "choropleth"
  }
};
export {
  u as ENABLE_POPSTATS_2023_LAYER_INFO
};
//# sourceMappingURL=index.es296.js.map
